const LANDSCAPE_DOCUMENT_SIZES = new Set([
  "landscape_letter",
  "landscape_legal",
]);

export const getDocumentSize = (formData = {}) =>
  formData?.updated_settings?.docSize ||
  formData?.settings?.docSize ||
  formData?.guessedFormDetails?.docSize ||
  formData?.form?.doc?.size ||
  "";

export const getDocumentDisplayRotation = (docSize = "") =>
  LANDSCAPE_DOCUMENT_SIZES.has(String(docSize).toLowerCase()) ? 90 : undefined;

export const getEffectivePageRotation = (pageRotation = 0, displayRotation) => {
  const hasConfiguredRotation =
    displayRotation !== undefined && displayRotation !== null;
  const rotation = hasConfiguredRotation
    ? Number(displayRotation) || 0
    : Number(pageRotation) || 0;

  return (rotation + 360) % 360;
};
